export default function isNum(value) {
    return /^\d+$/.test(value);
}
